<template>
  <div class="pages">
    <div class="cu_title" id="tag3">
      <div>{{ info.name }}</div>
      <img src="/static/other/icon_right.png" class="cImg" />
    </div>
    <div class="qz">
      <el-collapse accordion v-if="list.length">
        <el-collapse-item v-for="item in list" :key="item.id">
          <template slot="title">
            <div class="facab" style="width: 98%;">
              <div class="left">{{ item.title }}（ {{ item.job_num }} 名 ）</div>
              <div class="right">{{ item.department }}</div>
            </div>
          </template>
          <div class="cont" v-if="item.detail">
            <div>{{ $t('main.gwzc') }}：</div>
            <div v-html="item.detail.duty"></div>
            <div>{{ $t('main.gwyq') }}：</div>
            <div v-html="item.detail.jobposition"></div>
          </div>
        </el-collapse-item>
      </el-collapse>
      <div class="no-data" v-if="!list.length">{{ $t('main.noData') }}</div>
      <div>
        <el-pagination
          layout="prev, pager, next"
          hide-on-single-page
          :total="total"
          :current-page="page"
          :page-size="limit"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { getContents, getContentsDetail } from "@/api";

export default {
  data() {
    return {
      page: 1,
      limit: 10,
      total: 1000,
      items: [

      ],
      list: []
    };
  },
  props: ["steps", "info"],
  watch: {
    info: {
      immediate: true,
      handler: function(newV){
        this.getContent(newV);
      }
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.page = val;
      this.getContent(this.info)
    },
    getContent(data) {
      let params = {
        req: {
          cat_id: data.id,
          page: this.page,
          limit: this.limit,
          order: "orderby desc"
        }
      };
      getContents(params).then(res => {
        if(res.rsp.code === 0) {
          this.list = res.data.list;
          this.total = res.data.total;
          this.list.forEach(item => {
            this.getDetail(item.id);
          });
        }
      });
    },
    getDetail(id) {
      let params = {
        req: {
          id: id
        }
      };
      getContentsDetail(params).then(res => {
        if(res.rsp.code === 0) {
          this.list = this.list.map(item => {
            if(item.id === id) {
              return {
                ...item,
                detail: res.data
              };
            }
            return item;
          });
        }
      });
    }
  }
};
</script>
<style scoped lang="less">
.pages {
  .cu_title {
    margin-top: 3.25rem;
    font-size: 1.875rem;
    font-family: YouSheBiaoTiHei,serif;
    font-weight: 400;
    color: #666666;
  }
  .qz {
    margin-top: 1.5rem;
    padding-bottom: 3rem;

    .no-data {
      width: 100%;
      height: 80px;
      line-height: 80px;
      text-align: center;
      border: 1px solid #f5f5f5;
    }
    .left {
      color: #1a1a1a;
    }
    .right {
      color: #635796;
    }
    .cont {
      color: #1a1a1a;
    }

    /deep/ .el-pager li {
      background: #fff;
      margin: 0.1rem;
    }
    /deep/ .el-pagination {
      text-align: center;
    }
    /deep/ .el-pagination button:hover,.el-pagination button:focus,.el-pagination button:active {
      color: #635796;
    }
    /deep/ .el-pager li.active {
      background: #635796;
      color: #fff!important;
    }
    /deep/ .el-pager li:hover {
      background: #635796;
      color: #fff!important;
    }

    /deep/ .el-collapse-item__header {
      background-color: #fafafa;
      border: 1px solid #f2f2f2;
      font-size: 1.1428rem;
      padding: 0 1.875rem;
    }
    /deep/ .el-collapse-item + .el-collapse-item {
      margin-top: 0.8rem;
    }
    /deep/ .el-collapse-item__content {
      padding: 1rem 0 0 1.875rem;
      font-size: 1rem;
      line-height: 1rem;
    }
    /deep/ .el-collapse-item__wrap {
      border-bottom: 0;
    }
  }
}
</style>
